import {SharedTableHeadAttributes, SharedTableHeadTabNames} from "@/components/ProgressList/results/SharedTableHead";
import React from "react";
import {SharedTableBodyAttributes, SharedTableBodyTabs} from "@/components/ProgressList/results/SharedTableBody";
import * as Config from "@/config";
import {SortIndicator} from "@/components/SortIndicator";

interface FaqTableHeadProps {
  selectedProjectCategoryId?: number;
}

export const FaqTableHead = (props: FaqTableHeadProps) => {
  return (
    <>
      {/* カテゴリ列（project_category_id=8の場合のみ） */}
      {props.selectedProjectCategoryId === Config.PROJECT_CATEGORY_ID_FAQ && (
        <th rowSpan={2} className="sort-indicator-wrap" style={{width: '80px'}}>
          <div className="border-box"/>
          <div className="uk-text-center">カテゴリ</div>
          <SortIndicator item_name={Config.ProgressListSortItem.FAQ_CATEGORY} />
        </th>
      )}
      <SharedTableHeadAttributes/>
      <SharedTableHeadTabNames/>
      <th className="uk-padding-remove-horizontal">
        <div className="border-box"/>
        <div className="uk-text-center">公開設定</div>
      </th>
    </>
  )
}

interface FaqTableBodyProps {
  data: any;
  currentFaqStatuses: (data_id: number) => any;
  checked: boolean;
  selectedProjectCategoryId?: number;
}

export const FaqTableBody = (props: FaqTableBodyProps) => {
  return (
    <>
      {/* カテゴリ列（project_category_id=8の場合のみ） */}
      {props.selectedProjectCategoryId === Config.PROJECT_CATEGORY_ID_FAQ && (
        <td className={props.checked ? "selected" : ""}>
          <div className="border-box"/>
          <div className="uk-text-center">
            {props.data.project_category_id === Config.PROJECT_CATEGORY_ID_FAQ ? 'FAQ' : 
             props.data.project_category_id === Config.PROJECT_CATEGORY_ID_MYPAGE_TICKET ? 'My-P' : ''}
          </div>
        </td>
      )}
      <SharedTableBodyAttributes data={props.data} checked={props.checked} openMapModal={() => {}} isFaq={true}/>
      <SharedTableBodyTabs data={props.data}/>
      {/* 公開タブのステータスリスト */}
      <td data-tooltip-id="progress-tooltip">
        <div className="border-box"/>
        {props.currentFaqStatuses(props.data.id)?.statuses?.map((item: any, index: number) => {
          return (
            <div key={`progress-faq-table-body-${index}`}>{item.status}</div>
          )
        })}
      </td>

    </>
  )
}